<!-- Banner管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent">
        <div class="ele-table-tool-default">
          <el-button size="small" type="primary" icon="el-icon-plus" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addBanner">新建</el-button>
          <el-button size="small" type="primary" icon="el-icon-minus" :style="{backgroundColor: $store.state.deleteColor,borderColor: $store.state.deleteColor}" @click="delBanner">删除</el-button>
        </div>
        <el-table
          @selection-change="handleSelectionChange"
          row-key="id"
          class="table"
          ref="tableData"
          :data="table.tableData"
          border
          :tree-props="{children: 'children'}"
          :height="table.tableHeight"
          element-loading-text="拼命加载中,请等待"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column width="45" type="selection" :reserve-selection="true" align="center"></el-table-column>
          <el-table-column width="100" prop="id" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="图片" align="center">
            <template slot-scope="scope">
              <div class="demo-image__preview">
                <el-image style="width: 100px; height: 50px" :src="bindSrc(scope.row.img)"></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderinfo"  label="排序" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-bottom" :style="{color: $store.state.activeColor, padding:0, fontSize:'20px'}" @click="orderInfo('down', scope.row)"></el-button>
              <el-button type="text" icon="el-icon-top" :style="{color: $store.state.activeColor, padding:0, fontSize:'20px'}" @click="orderInfo('up', scope.row)"></el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleOperation('edit', scope.row)" icon="el-icon-edit" :style="{color: $store.state.activeColor}">编辑</el-button>
              <el-popconfirm class="real_pop" title="您确定要删除该Banner信息吗？" @confirm="handleOperation('remove', scope.row)">
                <el-button class="danger" slot="reference" type="text" size="mini" icon="el-icon-delete">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'BannerManagement',
    data () {
      return {
        table: { // 表格参数
          tableData:[], // 表格数据
          tableHeight: null, // 表格高度
          total: 0, // 表格总数
        },
        checkIds:[],//删除所选
      }
    },
    methods: {
      // 获取表格数据
      getList(){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        }];
        this.$api.findBanner({ page:1,size:this.$store.state.size,parameter: JSON.stringify(parameter)}).then(res => {
          if (res.data.status == 200) {
            this.table.total = Number(res.data.data.total);
            this.table.tableData = [];
            for(let i = 1; i <= this.table.total; i++){
              for (let j = 0; j < res.data.data.records.length; j++){
                if (i == res.data.data.records[j].orderinfo){
                  this.table.tableData.push(res.data.data.records[j]);
                }
              }
            }
            if(this.table.tableData != ""){
              this.$nextTick(() => {
                this.$refs.tableData.clearSelection();
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 拼接页面图片地址
      bindSrc(url){
        return api_url+"/"+url;
      },
      // 切换选择
      handleSelectionChange(val) {
        this.checkIds = [];
        if (val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            this.checkIds.push(val[i].id);
          }
        }
      },
      // 新建Banner
      addBanner(){
        this.$router.push({
          path:'/BannerManagementOperation',
          query:{ orderinfo: this.table.total+1}
        });
      },
      // 批量删除Banner
      delBanner(){
        for(let i = 0 ; i < this.table.tableData.length; i++){
          for(let j = 0; j < this.checkIds.length; j++){
            if (this.checkIds[j] == this.table.tableData[i].id){
              this.table.tableData[i].status = 0;
            }
          }
        }
        let index = 0;
        for (let i = 0; i < this.table.tableData.length; i++){
          if (this.table.tableData[i].status != 0){
            index++;
            this.table.tableData[i].orderinfo = index;
          }
        }
        this.setBatch('批量删除成功！');
      },
      // 改变orderInfo顺序
      orderInfo(type,data){
        if (this.table.tableData.length <=1){
          this.$message({
            message: '没有足够多的数据不能改变顺序！',
            type: 'warning'
          });
          return;
        }
        let index = 0;
        if (type == "up"){
          if (data == this.table.tableData[0]){
            this.$message({
              message: '第一个不能上移了！',
              type: 'warning'
            });
            return;
          }
          for (let i = 0; i < this.table.tableData.length; i++){
            if (data.id == this.table.tableData[i].id){
              index = i;
            }
          }
          let oldIndex = index - 1;
          this.table.tableData.splice(index - 1, 1, ...this.table.tableData.splice(oldIndex + 1, 1, this.table.tableData[index - 1]));
        } else {
          if (data == this.table.tableData[this.table.tableData.length-1]){
            this.$message({
              message: '最后一个不能下移了！',
              type: 'warning'
            });
            return;
          }
          for (let i = 0; i < this.table.tableData.length; i++){
            if (data.id == this.table.tableData[i].id){
              index = i;
            }
          }
          let oldIndex = index + 1;
          this.table.tableData.splice(index + 1, 1, ...this.table.tableData.splice(oldIndex - 1, 1, this.table.tableData[index + 1]));
        }
        for (let i = 0; i < this.table.tableData.length; i++){
          this.table.tableData[i].orderinfo = i+1;
        }
        this.setBatch('顺序改变成功！');
      },
      // 批量添加修改列表
      setBatch(title){
        this.$api.saveOrUpdateBannerBatch({ parameter: JSON.stringify(this.table.tableData)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 编辑/删除
      handleOperation(type,row){
        if (type == "edit") {  // 编辑操作
          this.$router.push({
            path:'/BannerManagementOperation',
            query:{ data:row }
          });
        } else if (type == "remove") { // 删除操作
          for(let i = 0 ; i < this.table.tableData.length; i++){
            if (row.id == this.table.tableData[i].id){
              this.table.tableData[i].status = 0;
            }
          }
          let index = 0;
          for (let i = 0; i < this.table.tableData.length; i++){
            if (this.table.tableData[i].status != 0){
              index++;
              this.table.tableData[i].orderinfo = index;
            }
          }
          this.setBatch('删除成功！');
        }
      },
      // table的高度
      getTableHeight(){
        let that = this;
        if($(".table").length > 0) {
          // 表格高度初始化事件
          $(".table").height(window.innerHeight - $(".table").offset().top - 25);
          $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 122);
          that.table.tableHeight = window.innerHeight - $(".table").offset().top - 25;
          // 窗口改变事件
          window.onresize = function () { // 定义窗口大小变更通知事件
            if($(".table").length > 0) {
              $(".table").height(window.innerHeight - $(".table").offset().top - 25);
              $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 122);
              that.table.tableHeight = window.innerHeight - $(".table").offset().top - 25;
            }
          };
        }
      },
    },
    mounted() {
      // 获取页面表格高度
      this.getTableHeight();
      // 获取列表
      this.getList();
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/BannerManagement.vue